module.exports = "../dist/img/mini-30.1195.jpg";